"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvertListFilter = void 0;
class AdvertListFilter {
    constructor(data) {
        this.limit = 50;
        this.skip = 0;
        this.orderBy = 'id';
        this.order = 'ASC';
        this.term = null;
        this.type = null;
        this.published = null;
        this.archived = null;
        this.isFree = null;
        this.specialties = [];
        this.professions = [];
        this.audiences = [];
        this.countries = [];
        this.role = null;
        this._model = "latest";
        if (data) {
            this.hydrate(data);
        }
    }
    hydrate(data) {
        for (const prop in data) {
            if (Object.prototype.hasOwnProperty.call(this, prop) && Object.prototype.hasOwnProperty.call(data, prop)) {
                this[prop] = data[prop];
            }
        }
    }
}
exports.AdvertListFilter = AdvertListFilter;
//# sourceMappingURL=AdvertListFilter.js.map